import { Button, Popover, Stack, Radio, Text, Group, Box } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'
import { useSortBy, type UseSortByProps } from 'react-instantsearch'
import Icon from 'components/Icon/Icon'
import { COLOR_NAMES } from 'Theme'

export const BRAND_PAGE_SORT_OPTIONS = [
  {
    value: 'products-v5/sort/availabilityOrder:asc,relevance:desc,title:asc',
    label: 'Relevance',
  },
  {
    value: 'products-v5/sort/availabilityOrder:asc,createdAt:desc',
    label: 'Newest',
  },
  {
    value: 'products-v5/sort/availabilityOrder:asc,minPrice:asc', // Todo: this will have to take into account trade price vs retail price
    label: 'Price: Low to high',
  },
  {
    value: 'products-v5/sort/availabilityOrder:asc,maxPrice:desc',
    label: 'Price: High to low',
  },
]

type TypeSenseSortByProps = {
  popover?: boolean
  defaultIndex?: number
} & Omit<UseSortByProps, 'items'>

// ToDo: Refactor with FavoritesSort
export const TypeSenseSortBy: React.FC<TypeSenseSortByProps> = ({
  popover = true,
  defaultIndex = 0,
  ...rest
}) => {
  const [isOpened, { toggle }] = useDisclosure(false)
  const { currentRefinement, refine } = useSortBy({
    ...rest,
    items: BRAND_PAGE_SORT_OPTIONS,
  })

  const selected =
    BRAND_PAGE_SORT_OPTIONS.find(
      (option) => option.value === currentRefinement
    ) || BRAND_PAGE_SORT_OPTIONS[defaultIndex]

  if (!popover) {
    return (
      <Box mb="2rem">
        <Group gap={4}>
          <Text fs="1.25rem" c="#181B19" mb="1rem">
            Sort by
          </Text>
        </Group>

        <Radio.Group
          value={selected.value}
          onChange={(value) => {
            refine(value)
          }}
        >
          <Stack>
            {BRAND_PAGE_SORT_OPTIONS.map((option) => (
              <Radio
                key={option.value}
                value={option.value}
                label={option.label}
                size="sm"
                styles={{
                  radio: {
                    cursor: 'pointer',
                  },
                  label: {
                    cursor: 'pointer',
                  },
                }}
              />
            ))}
          </Stack>
        </Radio.Group>
      </Box>
    )
  }

  return (
    <Popover
      opened={isOpened}
      onChange={toggle}
      position="bottom-end"
      shadow="md"
    >
      <Popover.Target>
        <Button
          variant="transparent"
          onClick={toggle}
          style={{ fontSize: 14 }}
          p={0}
        >
          <Group gap={4}>
            <Text c="#181B19">Sort by</Text>
            <Text c={COLOR_NAMES.PINEY_LAKE}>{selected.label}</Text>
            <Icon.ChevronFullDown size={20} />
          </Group>
        </Button>
      </Popover.Target>

      <Popover.Dropdown>
        <Radio.Group
          value={selected.value}
          onChange={(value) => {
            refine(value)
          }}
        >
          <Stack>
            {BRAND_PAGE_SORT_OPTIONS.map((option) => (
              <Radio
                key={option.value}
                value={option.value}
                label={option.label}
                size="sm"
                styles={{
                  radio: {
                    cursor: 'pointer',
                  },
                  label: {
                    cursor: 'pointer',
                  },
                }}
              />
            ))}
          </Stack>
        </Radio.Group>
      </Popover.Dropdown>
    </Popover>
  )
}
